<template>
    <AuthLayout class="designer-frame-layout">
        <FullscreenLoading v-if="isLoading" />

        <div class="mb-3 mt-3 d-flex align-items-center">
            <h3 class="mb-0" v-if="ceremony">{{ ceremony.name }}</h3>

            <div class="ml-auto text-right">
                <router-link tag="button" class="btn btn-secondary btn-xs ml-3" :to="{ name: 'ceremonies', query: { sync: ceremony?.id } }">
                    <icon name="arrow-left" class="mr-1"></icon>
                    Terug
                </router-link>
            </div>
        </div>

        <FullscreenIframe v-if="ceremony && !errorMessage" :src="ceremony.designer_link + '?locale=' + store.state.currentLocale + '&embed=true&token=' + token" @loading="isLoading = $event" />

        <div class="p-1" v-if="errorMessage">
            <div class="alert alert-danger">
                {{ errorMessage }}
            </div>
        </div>
    </AuthLayout>
</template>

<script setup>
    import AuthLayout from './AuthLayout.vue';
    import { onMounted, ref } from 'vue';
    import { IpcCall, ipcCall } from '../utils/ipcCall';
    import { useRoute } from 'vue-router/composables';
    import FullscreenIframe from './FullscreenIframe.vue';
    import store from '../../store/store';
    import i18n from '../../utils/locale';
    import FullscreenLoading from '../../components/FullscreenLoading.vue';

    const route = useRoute();

    const isLoading = ref(false);
    const errorMessage = ref(null);
    const ceremony = ref(null);
    const token = ref(null);

    onMounted(async () => {
        isLoading.value = true;

        try {
            const isOnline = await ipcCall(IpcCall.CheckIfOnline);

            if (!isOnline) {
                errorMessage.value = i18n.t('designer.designer_offline_error');
                isLoading.value = false;
                return;
            }

            token.value = await ipcCall(IpcCall.GetCurrentUserToken);
            ceremony.value = await ipcCall(IpcCall.GetExternalCeremony, {
                ceremonyId: route.params.ceremonyId,
            });

            // The loading will be removed by the iframe
        } catch (exception) {
            errorMessage.value = i18n.t('designer.failed_to_get_ceremony');
            isLoading.value = false;
            console.error(exception);
        }
    });
</script>
